import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { PaperMergeChildEntity } from "../entities/paper-merge-child.entity";

@Injectable()
export class PaperMergeChildRepo extends Repository<PaperMergeChildEntity>{
    constructor(private dataSource: DataSource) {
        super(PaperMergeChildEntity, dataSource.createEntityManager());
    }
}